import session from "../../../stores/session"

const SmartMeterRolloutConfig = {
    translations: [],
    uuidColumn: "Core_SPID",
    productId: "smart_meter_rollout",
    apiPrefix: "SMART_METER_ROLLOUT",
    purchaseTypePrefix: "smr",
    permissionPrefix: "SMART_METER_ROLLOUT",
    navigationPath: "smart-meter-rollout",
    exclusionReasons: [
        { value: 'Address Issue', label: 'Address Issue' },
        { value: 'Incorrect Occupier', label: 'Incorrect Occupier' },
        { value: 'No Contact', label: 'No Contact' },
        { value: 'Unable to Meter', label: 'Unable to Meter' },
        { value: 'Other', label: 'Other' }
    ],
    adcGroups: [
        "0.0-0.5",
        "0.5-1.0",
        "1-1.5",
        "1.5-2.0",
        "2.0+"
    ],
    statuses: ["New", "In Progress", "Lettered", "Called", "Visit Booked", "Rebooking Required"],
}

export default SmartMeterRolloutConfig;
